import * as actions from "../constants/actionTypes";
export const INITIAL_STATE = {
    userData: {
        name: "",
        _id: "",
        tickets: {
            regular: 0,
            gold: 0,
            platinum: 0,
        },
        locationInfo: {
            country: "",
            state: "",
            city: "",
            countryName: ""
        },
        gender: "",
        isBlocked: false,
        isReported: false,
        role: "",
        isVerify: true,
        created: "",
        modified: "",
        isDeleted: false,
        phone: "",
        referenceCode: "",
        countryCode: "",
        contestFilters: [],
        lastDateToReceiveDailyReward: "",
        code: "",
        codeExpiry: "",
        token: "",
        fcmToken: "",
        firstName: "",
        lastName: "",
        profilePic: "",
        email: "",
        countryName: "",
        enrolledContests: [],
        postBookmarkCount: 0,
        myVotesCount: 0,
        enableNotification: false
    },
    imageURL: "",
    profileImage: "",
    coverImage: "",
    coverImageURL: "",
    firstName: "",
    lastName: "",
    email: "",
    country: "",
    province: "",
    city: "",
    gender: "",
    savedPost: [],
    evaluationData: {
        userId: "",
        profilePic: "",
        firstName: "",
        lastName: "",
        description: "",
        mediaType: "",
        comment: "",
        locationInfo: {
            country: "",
            city: "",
            state: ""
        },
        votes: 0,
    },
    myVotes: { list: [] },
    hasMoreMyVotes: true,
    passwordChanged: false,
    phoneNoChanged: false,
    phoneVerified: false
};
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.GET_USER_SCCESS:
            let userData = { ...action.payload };
            return {
                ...state,
                userData,
                passwordChanged: false,
                firstName: userData.firstName,
                lastName: userData.lastName,
                email: userData.email,
                country: userData.locationInfo.country,
                province: userData.locationInfo.state,
                city: userData.locationInfo.city,
                gender: userData.gender.charAt(0).toUpperCase() + userData.gender.slice(1)
            }
        case actions.FILL_USER_PROFILE_DATA:
            let user = state.userData;
            return {
                ...state,
                firstName: user.firstName,
                lastName: user.lastName,
                email: user.email,
                country: user.locationInfo.country,
                province: user.locationInfo.state,
                city: user.locationInfo.city,
                gender: user.gender.charAt(0).toUpperCase() + user.gender.slice(1)
            }
        case actions.PROFILE_FIRST_NAME_CHANGED:
            return {
                ...state,
                firstName: action.payload
            }

        case actions.PROFILE_LAST_NAME_CHANGED:
            return {
                ...state,
                lastName: action.payload
            }

        case actions.PROFILE_EMAIL_CHANGED:
            return {
                ...state,
                email: action.payload
            }
        case actions.PROFILE_GENDER_CHANGED:
            return {
                ...state,
                gender: action.payload
            }

        case actions.PROFILE_COUNTRY_CHANGED:
            return {
                ...state,
                country: action.payload
            }

        case actions.PROFILE_PROVINCE_CHANGED:
            return {
                ...state,
                province: action.payload
            }

        case actions.PROFILE_CITY_CHANGED:
            return {
                ...state,
                city: action.payload
            }

        case actions.PROFILE_PROFILE_IMAGE_CHANGED:
            return {
                ...state,
                profileImage: action.payload.profileImage,
                imageURL: action.payload.imageURL,
            };

        case actions.PROFILE_COVER_IMAGE_CHANGED:
            return {
                ...state,
                coverImage: action.payload.coverImage,
                coverImageURL: action.payload.coverImageURL,
            };
        case actions.RESET_USER_PROFILE:
            return {
                ...state,
                phoneVerified: false,
                phoneNoChanged: false,
                passwordChanged: false,
                imageURL: "",
                profileImage: "",
                firstName: "",
                lastName: "",
                email: "",
                country: "",
                province: "",
                city: "",
                gender: "",
                savedPost: [],
                evaluationData: {
                    userId: "",
                    profilePic: "",
                    firstName: "",
                    lastName: "",
                    description: "",
                    mediaType: "",
                    comment: "",
                    locationInfo: {
                        country: "",
                        city: "",
                        state: ""
                    },
                    votes: 0,
                }
            }

        case actions.GET_SAVED_POST_DATA_SUCCESS:
            return {
                ...state,
                savedPost: action.payload.savedPost,
            }
        case actions.GET_MY_VOTES_DATA_SUCCESS:
            localStorage.setItem("loadMoreMyVotes", false);

            return {
                ...state,
                myVotes: action.payload.myVotes.list != undefined ? action.payload.newData ? action.payload.myVotes : { ...action.payload.myVotes, list: [...state.myVotes.list, ...action.payload.myVotes.list] } : state.myVotes,
                hasMoreMyVotes: action.payload.myVotes.list != undefined ? action.payload.newData ? action.payload.myVotes.list.length < action.payload.myVotes.totalRecords[0].count : state.myVotes.list.length + action.payload.myVotes.list.length < action.payload.myVotes.totalRecords[0].count : false,
            }
        case actions.RESET_SAVED_POST_DATA:
            return {
                ...state,
                savedPost: []
            }

        case actions.EVALUATION_DATA:
            return {
                ...state,
                evaluationData: action.payload
            }

        case actions.RESET_EVALUATION_DATA:
            return {
                ...state,
                evaluationData: {
                    userId: "",
                    profilePic: "",
                    firstName: "",
                    lastName: "",
                    description: "",
                    mediaType: "",
                    comment: "",
                    locationInfo: {
                        country: "",
                        city: "",
                        state: ""
                    },
                    votes: 0,
                }
            }
        case actions.NOTIFICATION_SWITCH_CHANGE:
            return { ...state, userData: { ...state.userData, enableNotification: action.payload } }
        case actions.USER_CHANGE_PASSWORD_SUCCESS:
            return { ...state, passwordChanged: true }
        case actions.USER_CHANGE_PHONE_NUMBER_SUCCESS:
            return { ...state, phoneNoChanged: action.payload }
        case actions.USER_PHONE_NUMBER_VERIFY_SUCCESS:
            return {
                ...state,
                phoneVerified: true
            }
        case actions.UPDATE_MEDIA_VIEW_COUNT_SAVEDPOST_SUCCESS: {
            let { savedPost } = state;
            savedPost[action.payload.index].viewCount += 1
            return {
                ...state,
                ...savedPost
            }
        }
        default:
            return state;
    }
};
